import * as React from 'react';
import brandLogo from "../assets/brand-logo.png";

 export default class EmailValidadoEnlaceExpiro extends React.Component {

    render() {
        return (
            <React.Fragment>
                <form id="resetpassword" className="backlogin h-100vh w-100">
                    <div className="login-title">
                        <img className="brand-logo mb-0" src={brandLogo} alt="brand-logo" />
                    </div> 
                    <div id="reset-form">
                        <h4 style={{fontSize: '1.5rem'}}> Validar Email</h4>
                        <br />
                        <div className="d-flex justify-content-center mx-auto"
                            style={{ marginBottom: "30px", lineHeight: "20px", width: '300px', fontSize: '14px' }}>
                            El enlace ha expirado o es Inválido.
                        </div>
                    </div>
                
                </form>
            </React.Fragment>
        )
    }
 }